import React from "react";

export default function QuickFacts({ pageTitle, isTop = false }) {
  return (
    <section 
      className={`hk-quick-facts-wrapper ${isTop ? "hk-top-section" : "py-3 py-md-4"} pb-4 px-3 m-0`} 
      style={{ background: "linear-gradient(180deg, #FAF6F0 0%, #F2EAE0 50%, #FAF6F0 100%)" }} 
      aria-label="Resort Quick Facts"
    >
      <div className="container" style={{ maxWidth: "1140px" }}>
        <div
          className="p-3 p-sm-4 p-md-5 position-relative overflow-hidden"
          style={{
            background: "#FFFFFF",
            borderRadius: "20px",
            border: "1.5px solid rgba(212, 175, 55, 0.45)",
            boxShadow: "0 12px 36px rgba(11, 29, 55, 0.08)",
            color: "#1A283B"
          }}
        >
          <div className="d-flex align-items-center gap-3 mb-3 pb-2 border-bottom" style={{ borderColor: "rgba(212, 175, 55, 0.25)" }}>
            <div
              className="d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
              style={{
                width: "44px",
                height: "44px",
                minWidth: "44px",
                minHeight: "44px",
                background: "linear-gradient(135deg, #FEA116 0%, #D4AF37 100%)",
                color: "#050E1A",
                fontSize: "1.2rem",
                boxShadow: "0 4px 12px rgba(254, 161, 22, 0.3)"
              }}
            >
              <i className="fas fa-crown"></i>
            </div>
            <div>
              <h2 className="m-0 font-weight-bold" style={{ color: "#0B1D37", fontFamily: "'Cinzel', serif", letterSpacing: "0.02em", fontSize: "clamp(1.1rem, 4vw, 1.35rem)", lineHeight: "1.3" }}>
                Quick Facts & Overview {pageTitle ? `— ${pageTitle}` : ""}
              </h2>
              <span className="d-block mt-1" style={{ fontSize: "clamp(0.75rem, 2.8vw, 0.82rem)", color: "#53647C" }}>
                HariKunj Resort Jodhpur | Luxury Heritage Resort &amp; Hotel
              </span>
            </div>
          </div>

          <p className="mb-4" style={{ fontSize: "0.95rem", lineHeight: "1.65", color: "#1A283B" }}>
            HariKunj Resort is a luxury heritage resort and boutique hotel located in Gopal Badi, Chopasni, Jodhpur, Rajasthan (342008). Combining traditional Rajasthani sandstone architecture with private pool amenities, gourmet dining, and lush lawns, it is Jodhpur&apos;s premier destination for families, events, and royal desert retreats.
          </p>

          <div className="row g-3" style={{ fontSize: "0.88rem" }}>
            <div className="col-12 col-md-6 col-lg-3">
              <div
                className="p-3 rounded-3 h-100 transition-all"
                style={{
                  background: "#FAF6F0",
                  border: "1px solid rgba(212, 175, 55, 0.3)",
                  boxShadow: "0 4px 12px rgba(11, 29, 55, 0.04)"
                }}
              >
                <div className="d-flex align-items-center gap-2 mb-2" style={{ color: "#D4AF37" }}>
                  <i className="fas fa-map-marker-alt flex-shrink-0" style={{ color: "#FEA116" }}></i>
                  <strong style={{ fontSize: "0.92rem", fontFamily: "'Cinzel', serif", color: "#0B1D37" }}>Location & Landmark</strong>
                </div>
                <p className="m-0" style={{ color: "#53647C", lineHeight: "1.45" }}>
                  Gopal Badi, Chopasni, Jodhpur, Rajasthan (1.5 Km from Umaid Sagar Bandh).
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div
                className="p-3 rounded-3 h-100 transition-all"
                style={{
                  background: "#FAF6F0",
                  border: "1px solid rgba(212, 175, 55, 0.3)",
                  boxShadow: "0 4px 12px rgba(11, 29, 55, 0.04)"
                }}
              >
                <div className="d-flex align-items-center gap-2 mb-2" style={{ color: "#D4AF37" }}>
                  <i className="fas fa-bed flex-shrink-0" style={{ color: "#FEA116" }}></i>
                  <strong style={{ fontSize: "0.92rem", fontFamily: "'Cinzel', serif", color: "#0B1D37" }}>Rooms & Rates</strong>
                </div>
                <p className="m-0" style={{ color: "#53647C", lineHeight: "1.45" }}>
                  Standard (₹3,999/n), Deluxe (₹4,999/n), Super Deluxe Suite (₹7,999/n).
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div
                className="p-3 rounded-3 h-100 transition-all"
                style={{
                  background: "#FAF6F0",
                  border: "1px solid rgba(212, 175, 55, 0.3)",
                  boxShadow: "0 4px 12px rgba(11, 29, 55, 0.04)"
                }}
              >
                <div className="d-flex align-items-center gap-2 mb-2" style={{ color: "#D4AF37" }}>
                  <i className="fas fa-swimming-pool flex-shrink-0" style={{ color: "#FEA116" }}></i>
                  <strong style={{ fontSize: "0.92rem", fontFamily: "'Cinzel', serif", color: "#0B1D37" }}>Key Amenities</strong>
                </div>
                <p className="m-0" style={{ color: "#53647C", lineHeight: "1.45" }}>
                  Swimming Pool, Rajasthani Dining, Spa, Event Lawns, Wi-Fi.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div
                className="p-3 rounded-3 h-100 transition-all"
                style={{
                  background: "#FAF6F0",
                  border: "1px solid rgba(212, 175, 55, 0.3)",
                  boxShadow: "0 4px 12px rgba(11, 29, 55, 0.04)"
                }}
              >
                <div className="d-flex align-items-center gap-2 mb-2" style={{ color: "#D4AF37" }}>
                  <i className="fas fa-clock flex-shrink-0" style={{ color: "#FEA116" }}></i>
                  <strong style={{ fontSize: "0.92rem", fontFamily: "'Cinzel', serif", color: "#0B1D37" }}>Timings & Contact</strong>
                </div>
                <p className="m-0" style={{ color: "#53647C", lineHeight: "1.45" }}>
                  Check-in: 12 PM | Check-out: 10 AM.<br />Phone: +91 9602588882.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
